import { FinancialConvo, FinancialConvoJSON } from "../models/FinancialConvo";
import { network } from "./index";
import { CognitoAuth } from "./CognitoAuth";

export class FinancialConvoAPI {
  async fetchRequests(
    includeDeleted = false,
    includeCompleted = false
  ): Promise<FinancialConvo[] | undefined> {
    try {
      let path = FinancialConvo.path;
      const pathParams = [];
      if (includeDeleted) pathParams.push("deleted=true");
      if (includeCompleted) pathParams.push("completed=true");

      if (pathParams.length > 0) {
        const pathParamsString = pathParams.join("&");
        path += `?${pathParamsString}`;
      }

      const response = await network.callGet(path);
      // an empty array of estates is a legitimate response
      return (
        response?.data?.map((json: any) => FinancialConvo.fromJSON(json)) || []
      );
    } catch (error) {
      CognitoAuth.handleError(error, "fetchRequests error");
    }
    return undefined;
  }

  async fetchSingleRequest(
    requestId: number
  ): Promise<FinancialConvo | undefined> {
    try {
      const response = await network.callGet(
        FinancialConvo.path + "/" + requestId,
        true
      );
      return FinancialConvo.fromJSON(response?.data);
    } catch (error) {
      CognitoAuth.handleError(error, "fetchSingleRequest error");
    }
    return undefined;
  }

  async fetchLatestRequest(
    includeDeleted = false,
    includeCompleted = false
  ): Promise<FinancialConvo | undefined> {
    try {
      let path = FinancialConvo.path + "-latest";
      const pathParams = [];
      if (includeDeleted) pathParams.push("deleted=true");
      if (includeCompleted) pathParams.push("completed=true");

      if (pathParams.length > 0) {
        const pathParamsString = pathParams.join("&");
        path += `?${pathParamsString}`;
      }

      const response = await network.callGet(path, true);
      return FinancialConvo.fromJSON(response?.data) || undefined;
    } catch (error) {
      // // CognitoAuth.handleError(error, "fetchSingleRequest error");
      // const axiosError = error as AxiosError;
      // if (axios(error as any)?.response?.status === 404) {
      //   // Do nothing.
      // } else if (axios(error as any)?.response?.status === 401) {
      //   // TODO: Error handling for auto
      //   logger.error(
      //     `401 : ${axios(error as any)?.response?.statusText}` ||
      //       "fetchLatestRequest error"
      //   );
      // } else {
      //   logger.error(
      //     `OTHER : ${axios(error as any)?.response?.statusText}` ||
      //       "fetchLatestRequest error"
      //   );
      // }
    }
    return undefined;
  }

  async createRequest(initialFields: FinancialConvoJSON): Promise<number> {
    try {
      const response = await network.callPost(
        FinancialConvo.path,
        initialFields
      );
      return response?.data?.id;
    } catch (error) {
      CognitoAuth.handleError(error, "createRequest error");
      throw error;
    }
  }

  async submitRequest(id: number): Promise<any> {
    try {
      const response = await network.callPost(
        FinancialConvo.path + "/submit/" + id
      );
      return response;
    } catch (error) {
      CognitoAuth.handleError(error, "submitRequest error");
      throw error;
    }
  }

  async checkRequestSubmit(id: number): Promise<boolean> {
    try {
      const response = await network.callPost(
        FinancialConvo.path + "/submission-status/" + id
      );
      return response?.data;
    } catch (error) {
      CognitoAuth.handleError(error, "checkRequestSubmit error");
      throw error;
    }
  }

  async updateRequest(
    id: number,
    updateFields: FinancialConvoJSON
  ): Promise<boolean> {
    try {
      await network.callPut(FinancialConvo.path + "/" + id, updateFields);
      return true;
    } catch (error) {
      CognitoAuth.handleError(error, "updateRequest error");
      throw error;
    }
  }

  async deleteRequest(id: number): Promise<boolean> {
    try {
      await network.callDelete(FinancialConvo.path + "/" + id);
      return true;
    } catch (error) {
      CognitoAuth.handleError(error, "deleteRequest error");
      throw error;
    }
  }
}
